import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, _STATE_STATEMENT_FEATURE_KEY } from './statements.reducer';

export const getStateStatements = createFeatureSelector<State>(
	_STATE_STATEMENT_FEATURE_KEY,
);

export const getStatementCategories = createSelector(
	getStateStatements,
	(state: State) => state.categories,
);

export const getStatementsByCategory = createSelector(
	getStateStatements,
	(state: State) => ({
		statements: state.statements,
	}),
);

export const getStatementArticle = createSelector(getStateStatements, (state: State) => ({
	statement: state.statement,
}));

export const getStatementIsLoading = createSelector(
	getStateStatements,
	(state: State) => state.isLoading,
);

export const getStatementError = createSelector(
	getStateStatements,
	(state: State) => state.error,
);

export const getStatementCategorySlug = createSelector(
	getStateStatements,
	(state: State) => state.categorySlug,
);
